module.exports = __webpack_public_path__ + "static/media/operador-logo-nossa-saude.396799f0.svg";